module.exports = __webpack_public_path__ + "static/media/flexline_black_logo_no.64f1a644.png";